export default {
    "fr": {
        "Cross-Channel platforms": "Plateformes transmanche",
        "ASA operates on the Port of Calais Transmanche and Eurotunnel - Getlink platforms": "ASA opère sur les plateformes Transmanche Port de Calais et Eurotunnel – Getlink.",
        "BIMS": "BIMS",
        "BIMS provides services in Boulogne sur Mer on our behalf": "BIMS assure les prestations à Boulogne sur Mer pour notre compte.",
        "ASA has a service point on the Calais Truckstop / Transmarck in Marck-en-Calaisis": "ASA dispose d’un point de services sur le parking Calais Truckstop / Transmarck à Marck-en-Calaisis."
    },
    "en": {
        "Cross-Channel platforms": "Cross-Channel platforms",
        "ASA operates on the Port of Calais Transmanche and Eurotunnel - Getlink platforms": "ASA operates on the Port of Calais Transmanche and Eurotunnel - Getlink platforms",
        "BIMS": "BIMS",
        "BIMS provides services in Boulogne sur Mer on our behalf": "BIMS provides services in Boulogne sur Mer on our behalf.",
        "ASA has a service point on the Calais Truckstop / Transmarck in Marck-en-Calaisis": "ASA has a service point on the Calais Truckstop / Transmarck in Marck-en-Calaisis."
    }
}
